import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const ContainerModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 5, 30, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  border-radius: 12px;
  padding: 28px 24px 20px 24px;
  min-width: 320px;
  max-width: ${({ $size }) => ($size === "wide" ? "720px" : "440px")};
  width: ${({ $size }) => ($size === "wide" ? "94%" : "90%")};
  position: relative;
  border: 1.5px solid rgba(76, 4, 140, 0.22);
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.06),
    0 24px 48px -12px rgba(76, 4, 140, 0.32);
  overflow: hidden;
  font-family: ${FONT_STACK};
  font-feature-settings: "cv11", "ss01";
  -webkit-font-smoothing: antialiased;
  animation: slideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  h1,
  h2,
  h3,
  p {
    font-family: ${FONT_STACK};
    color: var(--grisOscuro);
    margin: 4px 0;
    text-align: center;
    line-height: 1.4;
    letter-spacing: -0.015em;
  }

  h2 {
    font-size: 1.1rem;
    font-weight: 600;
  }

  p {
    font-size: 0.92rem;
    font-weight: 500;
  }

  .modal-body {
    width: 100%;
    padding: 8px 4px 18px 4px;
    text-align: ${({ $size }) => ($size === "wide" ? "left" : "center")};
    color: var(--grisOscuro);
    font-size: 0.95rem;
    font-weight: 500;
    word-break: break-word;
  }

  @media (max-width: 800px) {
    width: 90%;
    min-width: 0;
  }
`;

export const CloseButton = styled.button`
  background: rgba(76, 4, 140, 0.06);
  border: none;
  font-size: 18px;
  line-height: 1;
  font-weight: 500;
  color: var(--grisMedio);
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: rgba(76, 4, 140, 0.14);
    color: var(--violetaOscuro);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ButtonAceptar = styled.button`
  font-family: ${FONT_STACK};
  background: linear-gradient(
    180deg,
    var(--violetaPastelOscuro) 0%,
    var(--violetaOscuro) 100%
  );
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 36px;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 8px;
  transition:
    transform 0.08s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
  box-shadow: 0 2px 8px rgba(76, 4, 140, 0.25);

  &:hover {
    background: linear-gradient(
      180deg,
      var(--violeta) 0%,
      var(--violetaPastelOscuro) 100%
    );
    box-shadow: 0 4px 14px rgba(76, 4, 140, 0.38);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 2px 8px rgba(76, 4, 140, 0.25),
      0 0 0 3px rgba(203, 182, 219, 0.45);
  }
`;

export const ButtonCancelar = styled.button`
  font-family: ${FONT_STACK};
  background: transparent;
  color: var(--violetaOscuro);
  border: 1.5px solid rgba(76, 4, 140, 0.28);
  border-radius: 8px;
  padding: 10px 36px;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 8px;
  transition:
    transform 0.08s ease,
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: rgba(76, 4, 140, 0.08);
    border-color: rgba(76, 4, 140, 0.45);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.45);
  }
`;
